<div class="icon-container">
  <svg width="27" height="41" viewBox="0 0 27 41" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 3L21.1483 16.4038C23.9919 18.3943 23.9919 22.6057 21.1483 24.5962L2 38" stroke="white" stroke-width="4"
      stroke-linecap="round" />
  </svg>
</div>
